import { render, staticRenderFns } from "./CollectionUnitsVertical.vue?vue&type=template&id=226b892d"
import script from "./CollectionUnitsVertical.vue?vue&type=script&lang=js"
export * from "./CollectionUnitsVertical.vue?vue&type=script&lang=js"
import style0 from "./CollectionUnitsVertical.vue?vue&type=style&index=0&id=226b892d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports